import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import Fingerprintattendancesystem from "../../Assets/Projects/Fingerprint attendance system.png";
import Studentmanagementsystem from "../../Assets/Projects/Student management system.png";
import EIP from "../../Assets/Projects/EIP.png";
import Portfolio from "../../Assets/Projects/Portfolio.png";
import TaskManger from "../../Assets/Projects/Task Manger.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={TaskManger}
              isBlog={false}
              title="Task Manager"
              description="A full-stack Task Management Application built using Spring Boot and React.js. It allows users to create, assign, and track tasks with features like user authentication, role-based access, task filtering, status updates, and progress tracking. The application integrates RESTful APIs and ensures a responsive UI with seamless frontend-backend communication."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={EIP}
              isBlog={false}
              title="EIP React Conversion"
              description="A modernization project where the legacy EIP (Enterprise Information Portal) system was converted into a React.js application. Enhanced UI performance, improved maintainability, and optimized state management using React Hooks and Context API. Integrated API endpoints and modularized components for scalability and faster load times."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Portfolio}
              isBlog={false}
              title="Portfolio Website"
              description="A personal portfolio website built using React.js to showcase my skills, experience, and projects. Designed with a responsive layout, interactive animations, and reusable components. Includes sections for education, work experience, and project highlights, with a clean and modern UI inspired by professional developer portfolios."
              // ghLink="https://github.com/saiharshithadurthy/Portfolio"
              // demoLink="https://saiharshithadurthy.github.io/Portfolio/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Studentmanagementsystem}
              isBlog={false}
              title="Student Management System"
              description="A web-based system developed during my internship using Java, HTML, CSS, and MySQL. It allows administrators to manage student records, attendance, and performance efficiently. The project features CRUD operations, search functionality, and a user-friendly interface for easy navigation and data handling."
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Fingerprintattendancesystem}
              isBlog={false}
              title="Fingerprint Attendance System"
              description="An IoT-based attendance system built using fingerprint sensors and microcontrollers to automate student attendance. The system identifies students through biometric verification and securely stores attendance records in a database, improving accuracy and eliminating manual errors."
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
